<template>

  <div class="home">
     
    <div v-if="isProvinceManage" class="admin" @click="toManage" href="#/manage/course" target="_blank"><i class="icon"></i>后台管理</div>
    <!-- <s-header />
    <AppHeader showMenu :showModule="false" /> -->
    <ahedu-header activeName="应用中心" /> 
    <!-- <left-section /> --> 
    <div class="swiper">
      <div class="swiper-button prev" @click="$refs.ElCarousel.prev()"></div>
      <el-carousel ref="ElCarousel" :interval="0" type="card" height="300px" arrow="never">
        <el-carousel-item v-for="(item, index) in swiper" :key="index">
          <a :href="item.link ? item.link : 'javascript:void(0);'" :target="item.link ? '_blank' : ''" rel="noopener noreferrer">
            <img :src="item.img" alt="" />
          </a>
        </el-carousel-item>
      </el-carousel>
      <div class="swiper-button next" @click="$refs.ElCarousel.next()"></div>
    </div>
    <div class="streaming">
      <div class="panel-title">
        <h3 class="panel-label">
          <span class="blue">活动日历</span>
          <span class="gray">CALENDAR</span>
        </h3>
        <!-- <div class="btn-manage">
          <el-button type="primary" size="small" plain  @click="$router.push({name:'ManageList'})">后台管理</el-button>
          
        </div> -->
        <img class="more" src="../assets/img/home/more.png" alt="更多>>" @click="$router.push('/streaming')" />
      </div>
      <div class="streaming-container">
        <AppCalendar class="calendar" @changeMonth="changeMonth" @choseDay="choseDay" ref="calendar"></AppCalendar>

        <el-timeline v-if="activities.length">
          <el-timeline-item placement="top" color="#368fff" v-for="(activity, index) in activities" :key="index" :timestamp="activity.timestamp">
            <div class="streaming-item" v-for="(item, index) in activity.list" :key="index">
              <div class="streaming-item-info">
                <h6>{{ item.name }}</h6>
                <p>
                  <i class="el-icon-time"></i> 直播时间: {{ item.startTime }} 至
                  {{ item.endTime }}
                </p>
              </div>
              <el-button v-if="item.isLive" class="streaming-button1" @click="goLive(item, 'stream')">
                观看直播
              </el-button>
              <el-button v-if="item.status === 2" class="streaming-button" @click="goLive(item, 'video')">
                观看回放
              </el-button>
            </div>
          </el-timeline-item>
        </el-timeline>
        <div v-else class="no_data">暂无数据~</div>
      </div>
    </div>
    <div class="archive">
      <div class="panel-title">
        <h3 class="panel-label">
          <span class="blue">精彩回放</span>
          <span class="gray">WONDERFUL PLAYBACK</span>
        </h3>
        <img class="more" src="../assets/img/home/more.png" alt="更多>>" @click="$router.push('/archive')" />
      </div>
      <div class="archive-container">
        <div class="archive-chart">
          <h3 class="title">活动统计</h3>
          <div class="top-num">
            <div class="top-num-item">
              <div class="top-card-wrap">
                <span v-for="(item, index) in homeTotal" :key="index">
                  <b>{{ item }}</b>
                </span>
              </div>
              总数
            </div>
            <div class="top-num-item">
              <div class="top-card-wrap">
                <span v-for="(item, index) in homeNew" :key="index">
                  <b>{{ item }}</b>
                </span>
              </div>
              本月新增
            </div>
          </div>
          <h3 class="title">学科分布</h3>
          <!-- <img class="my-chart" :src="homeChart" alt="" /> -->
          <div class="my-chart">
            <subjectScatter :subjectData="subjectData"></subjectScatter>
          </div>
        </div>
        <div class="archive-warp">
          <AppArchive v-for="(item, index) in archive" :key="index" :archive="item" />
        </div>
      </div>
    </div>
    <AppFoot showCopyRight showLink :showContect="false" />
  </div>
</template>

<script>
// import * as echarts from 'echarts';
import { mapState } from 'vuex'
import subjectScatter from '@/components/subjectScatter'
import SHeader from './SmartEducation/header.vue';
import leftSection from '@/components/fixleft.vue';
// const {
//   VUE_APP_APPNAME,
//   VUE_APP_APPKEY,
//   VUE_APP_SSOSERVERURL,
//   VUE_APP_LOGINREDIRECTURL
// } = process.env

export default {
  name: "",
  components: {
    subjectScatter,
    SHeader,
    leftSection
  },
  props: {},
  data() {
    return {
      swiper: window.APP_CONFIG.banner,
      activities: [],
      archive: [],
      homeTotal: "000", // 资源总数
      homeNew: "000", // 本月新增
      homeChart: window.APP_CONFIG.homeChart,
      timeInterVal: null,
      subjectData: [],
   
    };
  },
  computed: {
    ...mapState({
      isProvinceManage: state => state.isProvinceManage
    }),
  },
  created() {
    this.listResource();
    this.getCountResource();
    this.getSbujectData()
  },
  mounted() {
     
  },
  methods: {
    async getSbujectData() {
      // 过滤掉小于5%的部分显示其他
      const { data } = await this.$api.res.subjectDistribution({});
      const values = Object.values(data)
      const total = values.reduce((p, c) => p + c)
      let filterIndex = [], filterValue = []
      values.forEach((element, index) => {
        if (element / total < 0.05) {
          filterIndex.push(index)
          filterValue.push(element)
        }
      });
      const getOtherObj = () => {
        const otherValue = filterValue.reduce((p, c) => p + c)
        return {
          name: '其他',
          value: otherValue
        }
      }
      const getResult = () => {
        let subjectData = []
        for (const key in data) {
          subjectData.push({ name: key, value: data[key], percent: data[key] / total })
        }
        subjectData = subjectData.filter((ele) => ele.percent > 0.05)
        filterIndex.length > 0 && subjectData.push(getOtherObj())
        return subjectData
      }
      this.subjectData = getResult()
    },
    // 进入直播页面
    goLive(item, type) {
      console.log(item);
      type === 'stream' && this.getLiveUrl(item.liveId);
      type === 'video' && window.open(this.$router.resolve({ name: "archiveDetail", query: { detailId: item.liveId } }).href, '_blank')
      // // SSO配置
      // window.SSO.appName = VUE_APP_APPNAME
      // window.SSO.appKey = VUE_APP_APPKEY
      // window.SSO.SSOServerUrl = VUE_APP_SSOSERVERURL
      // window.SSO.loginRedirectUrl = VUE_APP_LOGINREDIRECTURL
      // // 登录状态
      // window.SSO.getLoginState((res) => {
      //   console.log(res)
      //   const isLogin = res.code === 1001
      //   if (isLogin) {
      //     window.localStorage.setItem('st', res.data.st)
      //     window.localStorage.setItem('tgt', res.data.tgt)
      //     type === 'stream' && this.getLiveUrl(item.liveId);
      //     type === 'video' && window.open(this.$router.resolve({ name: "archiveDetail", query: { detailId: item.liveId } }).href, '_blank')
      //   } else {
      //     window.open(VUE_APP_LOGINREDIRECTURL, "_blank");
      //   }
      // })
      // window.SSO.client = "web";
      // //TODO 根据实际应用使用的appKey标识填写
      // window.SSO.mac = window.SSO.deviceId;
      // window.SSO.customLogoutUrl = "";
      // window.SSO.needAttribute = true;
      // window.SSO.SSOServerUrl = process.env.VUE_APP_SSO_URL;
      // window.SSO.SSOCenterServerUrl = process.env.VUE_APP_SSO_URL;
      // window.SSO.loginRedirectUrl = "";
      // window.SSO.isCenterSSO = true;
      // window.SSO.accountTypeIsAuto = true;
      // window.SSO.needToken = true;
      // window.SSO.appKey = "8a1061d2a87344dd87e3b6e8ed10ac32";
      // window.SSO.getAccessToken((result) => {
      //     // 登录
      //   if (result.code === "1") {
      //     // localStorage.setItem("token", result.data.token);
      //     // localStorage.setItem("clientType", window.APP_CONFIG.clientType); // 配置文件
      //     // localStorage.setItem("deviceId", SSO.deviceId);
      //     // localStorage.setItem("appKey", window.APP_CONFIG.appKey); // 配置文件
      //     type === 'stream' && this.getLiveUrl(item.liveId);
      //     type === 'video' && window.open(this.$router.resolve({name: "archiveDetail",query: {detailId: item.liveId}}).href, '_blank')
      //   } else {
      //     window.open(process.env.VUE_APP_LOGIN_URL, "_blank");
      //   }
      // });
    },
    // 获取直播地址
    async getLiveUrl(liveId) {
      let req = {
        liveId,
      };
      let { code, data } = await this.$api.live.getLiveUrl(req);
      if (code === "1") {
        if (data) {
          // 有直播地址
          window.open(data, "_blank");
        } else {
          let href = this.$router.resolve({
            name: "live",
            query: {
              liveId: liveId,
            },
          });
          window.open(href.href, "_blank");
        }
      }
    },
    changeMonth() {
    },
    choseDay(val) {
      this.getLiveList(val);
    },
    // 获取直播列表
    async getLiveList(startTime) {
      let val = startTime.replace(/\//g, "-");
      let date = this.dateFormat(val);
      let req = {
        startTime: date,
        limit: 4,
      };
      let { code, data } = await this.$api.live.topLive(req);
      if (code === "1") {
        // let reveseData = data.reverse(); // 正序(时间 小-大);
        let list = [];
        data.map((item) => {
          item["startNow"] = new Date(item.startDate).getTime(); // 直播开始时间的时间戳
          item["endNow"] = new Date(item.endDate).getTime(); // 直播节数时间的时间戳
          item["isLive"] = false; // 是否显示 '观看直播'
          if (!list.length) {
            list.push({
              timestamp: item.startTime.split(" ")[0], // 日期
              list: [item],
            });
          } else {
            let date = item.startTime.split(" ")[0];
            let flag = false;
            list.map((i) => {
              if (i.timestamp === date) {
                // 同一天
                flag = true;
                i.list.push(item);
              }
            });
            if (!flag) {
              list.push({
                timestamp: item.startTime.split(" ")[0], // 日期
                list: [item],
              });
            }
          }
        });
        this.activities = list;
        if (this.timeInterVal) {
          clearInterval(this.timeInterVal);
        }
        this.interVal();
      }
    },
    dateFormat(date) {
      let dateArr = date.split('-');
      let [y, m, d] = [dateArr[0], dateArr[1], dateArr[2]];
      m = Number(m) > 9 ? m : '0' + m;
      d = Number(d) > 9 ? d : '0' + d;
      return `${y}-${m}-${d}`
    },
    // 获取视频资源
    async getCountResource() {
      let { code, data } = await this.$api.res.getCountResource();
      if (code === "1") {
        let total = "000";
        let monthCount = "000";
        let totalLen = String(data.total).length;
        let monthLen = String(data.month).length;
        if (totalLen === 1) total = "00" + data.total;
        if (totalLen === 2) total = "0" + data.total;
        if (totalLen === 3) total = "" + data.total;
        if (monthLen === 1) monthCount = "00" + data.month;
        if (monthLen === 2) monthCount = "0" + data.month;
        if (monthLen === 3) monthCount = "" + data.month;
        this.homeTotal = total;
        this.homeNew = monthCount;
      }
    },
    // 定时器 观看直播
    interVal() {
      this.timeInterVal = setInterval(() => {
        let currentDate = new Date().getTime(); // 当前的时间戳
        this.activities.map((item) => {
          item.list.map((v, i) => {
            // console.log(i);
            // console.log(item.list[i], v);
            if (currentDate > v.startNow && currentDate < v.endNow) {
              v.isLive = true;
              this.$set(item.list[i], 'isLive', true);
            }
          });
        });
      }, 1000);
    },
    async listResource() {
      let {
        data: { rows = [] },
      } = await this.$api.res.listResource({
        pageNum: 1,
        pageSize: 6,
        type: "4",
      });
      console.log("1",rows)
      this.archive = rows;
    },
    destroyed() {
      if (this.timeInterVal) clearInterval(this.timeInterVal);
    },
    toManage() {
      let routeUrl = this.$router.resolve({ path: '/manage/course' })
      window.open(routeUrl.href, '_blank')
    }
    }
  
};
</script>
<style scoped lang="less">
.home {
  overflow: hidden;
  background: url('../assets/img/home/bg-home.png') top left / 100% 100%
    no-repeat;
  .admin {
    position: fixed;
    z-index: 1000;
    right: 100px;
    bottom: 100px;
    width: 60px;
    padding: 60px 20px 20px;
    cursor: pointer;
    color: #262626;
    border: 2px solid #fff;
    border-radius: 30px;
    background: linear-gradient(to bottom, #f7fbff, #fff);
    box-shadow: 0 0 18px rgba(151, 165, 180, 0.2);
    box-sizing: border-box;
    // writing-mode: vertical-lr;
    &:hover {
      color: #fff;
      border-color: #368fff;
      background: #368fff;
      .icon {
        background: url('../assets/img/icon-manage-hover.png');
      }
    }
    .icon {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 30px;
      height: 28px;
      transform: translateX(-50%);
      background: url('../assets/img/icon-manage.png');
    }
  }
  .swiper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 60px auto 30px;
    .swiper-button {
      width: 78px;
      height: 78px;
      &.prev,
      &.prev:hover,
      &.next,
      &.next:hover {
        cursor: pointer;
        transition: all 0s;
        transform: rotate(0);
      }
      &.prev,
      &.next {
        background: url('../assets/img/home/swiper-arrow.png');
      }
      &.prev:hover,
      &.next:hover {
        background: url('../assets/img/home/swiper-arrow-active.png');
      }
      &.prev:hover,
      &.next {
        transform: rotate(180deg);
      }
    }
    .el-carousel {
      width: 1200px;
      .el-carousel__item {
        &.is-active {
          width: 866px;
          transform: translateX(167px) scale(1) !important;
        }
        a,
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .panel-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid #e7e9ec;
    .panel-label {
      .blue {
        display: inline-block;
        margin: -1px 10px -1px 0;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-size: 26px;
        font-weight: 600;
        line-height: 50px;
        color: #333;
        border-bottom: 2px solid #368fff;
        background: linear-gradient(180deg, #368fff 0%, #0856b8 100%);
        -webkit-background-clip: text;

        -webkit-text-fill-color: transparent;
      }
      .gray {
        font-family: PingFangSC-Semibold, PingFang SC;
        font-size: 19px;
        font-weight: 600;
        line-height: 26px;
        color: #d2d2d2;
      }
    }
    .more {
      width: 38px;
      height: 18px;
      cursor: pointer;
    }
  }
  .streaming {
    overflow: hidden;
    .streaming-container {
      display: flex;
      width: 1200px;
      margin: 20px auto 0;
      .no_data {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: center;
        color: #999;
      }
      .calendar {
        width: 500px;
        min-width: 500px;
        margin: 0 20px 0 0;
        background: url('../assets/img/home/bg-calendar.png') center / 108% 108%
          no-repeat;
      }
      ::v-deep .el-timeline {
        flex: 1;
        .el-timeline-item__timestamp {
          // width: 86px;
          height: 22px;
          margin-bottom: 6px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          color: #262626;
        }
      }
      .streaming-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        width: 688px;
        height: 83px;
        margin-bottom: 20px;
        padding: 20px 12px;
        background: linear-gradient(180deg, #f4f8ff 0%, #fff 100%);
        box-shadow: 0px 2px 20px 0px rgba(119, 135, 182, 0.17);
        &:last-child {
          margin-bottom: 0;
        }
        .streaming-item-info {
          flex: 1;
          h6 {
            margin-bottom: 10px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #262626;
          }
          p {
            font-family: PingFangSC-Regular, PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            color: #8c8c8c;
          }
        }
        .streaming-button {
          width: 90px;
          height: 32px;
          padding: 0;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: #368fff !important;
          border-color: #368fff !important;
          &:hover {
            background: #fff;
          }
          &.pre {
            color: #ffae00 !important;
            border-color: #ffae00 !important;
          }
        }
        .streaming-button1 {
          width: 90px;
          height: 32px;
          padding: 0;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: #ffae00 !important;
          border-color: #ffae00 !important;
          &:hover {
            background: #fff;
          }
          &.pre {
            color: #ffae00 !important;
            border-color: #ffae00 !important;
          }
        }
      }
    }
  }
  .archive {
    margin: 40px 0 50px;
    .archive-container {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 20px auto 0;
      .archive-chart {
        box-sizing: border-box;
        width: 282px;
        height: 504px;
        margin-right: 20px;
        padding: 20px;
        background: url('../assets/img/home/bg-chart.png') center / 118%
          no-repeat;
        h3.title {
          width: 186px;
          height: 45px;
          padding: 0 10px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-size: 20px;
          font-weight: 500;
          line-height: 45px;
          color: #fff;
          background: linear-gradient(
            86deg,
            #368fff 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }
        .top-num {
          display: flex;
          justify-content: space-between;
          margin: 20px 0 20px;
          .top-num-item {
            width: 111px;
            height: 115px;
            text-align: center;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #368fff;
            background: url('../assets/img/home/bg-chart-item.png') center /
              100% no-repeat;
            .top-card-wrap {
              display: flex;
              justify-content: space-between;
              height: 46px;
              margin: 25px 11px 11px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-size: 28px;
              font-weight: 500;
              line-height: 40px;
              color: #134787;
              span {
                position: relative;
                flex: 1;
                height: 42px;
                b {
                  position: absolute;
                  z-index: 1;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
                &::before {
                  position: absolute;
                  top: 0;
                  right: 2px;
                  bottom: 50%;
                  left: 2px;
                  content: '';
                  border: 1px solid #fff;
                  background: #d1e5ff;
                }
                &::after {
                  position: absolute;
                  top: 50%;
                  right: 2px;
                  bottom: 0;
                  left: 2px;
                  content: '';
                  border: 1px solid #fff;
                  background: #9dc8ff;
                }
              }
            }
          }
        }
        .my-chart {
          width: 240px;
          height: 200px;
          margin-top: 20px;
        }
      }
      .archive-warp {
        flex: 1;
        .app-archive {
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.btn-manage {
  flex: 1;
  padding-right: 10px;
  text-align: right;
  font-size: 14px;
}
//飘窗
#gg2b .notice-close {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 24px;
  height: 24px;
  background: url('~@/assets/img/notice_close.png') no-repeat;
}
</style>
